import React, { SVGProps } from 'react';

const XpStatIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 21 21"
			fill="none"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.5 4.41667C0.5 2.11548 2.36548 0.25 4.66667 0.25H16.3333C18.6345 0.25 20.5 2.11548 20.5 4.41667V16.0833C20.5 18.3845 18.6345 20.25 16.3333 20.25H4.66667C2.36548 20.25 0.5 18.3845 0.5 16.0833V4.41667ZM4.66667 1.91667C3.28595 1.91667 2.16667 3.03595 2.16667 4.41667V16.0833C2.16667 17.464 3.28595 18.5833 4.66667 18.5833H16.3333C17.714 18.5833 18.8333 17.464 18.8333 16.0833V4.41667C18.8333 3.03595 17.714 1.91667 16.3333 1.91667H4.66667Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.56429 10.1221C6.02453 10.1221 6.39762 10.4952 6.39762 10.9554L6.39762 15.1862C6.39762 15.6464 6.02453 16.0195 5.56429 16.0195C5.10405 16.0195 4.73096 15.6464 4.73096 15.1862L4.73096 10.9554C4.73096 10.4952 5.10405 10.1221 5.56429 10.1221Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.4998 7.30176C10.9601 7.30176 11.3332 7.67485 11.3332 8.13509V15.1864C11.3332 15.6466 10.9601 16.0197 10.4998 16.0197C10.0396 16.0197 9.6665 15.6466 9.6665 15.1864V8.13509C9.6665 7.67485 10.0396 7.30176 10.4998 7.30176Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.4359 4.48047C15.8961 4.48047 16.2692 4.85356 16.2692 5.3138V15.1856C16.2692 15.6458 15.8961 16.0189 15.4359 16.0189C14.9756 16.0189 14.6025 15.6458 14.6025 15.1856V5.3138C14.6025 4.85356 14.9756 4.48047 15.4359 4.48047Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default XpStatIcon;
